export const notifications = {
  title: '通知',
  markAsRead: '標記為已讀',
  markAllAsRead: '全部標記為已讀',
  noNotifications: '沒有通知',
};